import { render, staticRenderFns } from "./Ptspkota.vue?vue&type=template&id=ea6441ee"
import script from "./Ptspkota.vue?vue&type=script&lang=js"
export * from "./Ptspkota.vue?vue&type=script&lang=js"
import style0 from "./Ptspkota.vue?vue&type=style&index=0&id=ea6441ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports